import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LicenseQueryKey } from './queryKey';
export const useGetLicenseInfo = (enabled = true) => {
    const intl = useIntl();
    return useQuery([LicenseQueryKey.Info], () => api.base.get('/api/License/Info').then(res => res.data), {
        enabled,
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
export default useGetLicenseInfo;
